import React from 'react';
import './AuthPage.css';

import { API_BASE_URL } from '../config';

const AuthPage = () => {
  const handleLogin = () => {
    window.location.href = `${API_BASE_URL}/auth/42`;
  };

  return (
    <div className="auth-container">
      <div 
        className="auth-background" 
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/rabat_compus.png)` }}
      ></div>
      <div className="auth-content">
        <h1 className="auth-title">1337 MintraLib</h1>
        <p className="auth-subtitle">Projects Library</p>
        <button className="auth-button" onClick={handleLogin}>
            Login with 42
        </button>
      </div>
    </div>
  );
};

export default AuthPage;
